import type { PutTranslationTextDTO } from '../service/ai-translation.repository.interface';
import type { PutTranslationTextRequest } from '../type/ai-translation.type';
import { injectable, inject } from '@patsnap/tahiti-core/shared/inversify';
import { PutTranslationText } from '@/infrastructure/api-functions/interface/put-translation-text.interface';

@injectable()
export class PutTranslationTextDTOImpl implements PutTranslationTextDTO {
    constructor(
        @inject(PutTranslationText)
        private readonly _putTranslationTextApi: PutTranslationText,
    ) { }

    async fetch(value: PutTranslationTextRequest): Promise<void> {
        const params = {
            current_step: value.currentStep,
            original_index: value.originalIndex,
            task_id: value.taskId,
            translation_text: value.translationText,
        };
        await this._putTranslationTextApi.putTranslationText(params);
    }
}
